import { Button, Container } from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
// import { useParams } from "react-router";
import Loading from "../helper/Loading";
import PageHeader from "../helper/PageHeader";
import SimpleTable from "../helper/SimpleTable";
import UserInfoDisplay from "../helper/UserInfoDisplay";
import { withTranslation } from 'react-i18next';

// username, trainingId, courseID is from location state
const TrainingHistDetails = props => {
    const mounted = useRef(true)
    // const params = useParams()
    const history = useHistory()
    const {t} = props;

    const [data, setData] = useState({ loading: true, data: null })
    const [userData, setUserData] = useState({ DOB: null, email: null, first_name: null, last_name: null, username: null }) // user account info from the get request, could have used authContext, but admin and employer will not be able to use it, so I just made dashboard also use the same get request

    // grab training course id from location stat (the id for each course record)
    const locState = history.location.state
    const { username, trainingId, courseID, courseLabel, courseType } = locState
    // for restricted, do not display dob, remove score link and disable quiz history
    const restricted = locState.restricted ? true : false

    console.log(locState);

    useEffect(() => {
        async function getData() {

            const res = await axios.all([
                axios.get('/api/courseProgress/children', {
                    params: {
                        username,
                        courseID,
                        trainingId,
                    }
                }),
                axios.get('/api/user/info/' + username)
            ])
            console.log(res)
            const data = res[0].data.result
            // let data = res.data.course
            data.map(e => {
                e.statusView =  e.STATUS ? t('lmsStatus.Status', { context: e.STATUS }) : null;
                e.actionsDisabled = {
                    hasQuiz: !(e.postTestLink === ""), //removes the view quiz hist button
                
                    view: e.STATUS === undefined, // disables course hist button
                    quiz: e.highestScore === undefined || restricted//disables quiz hist button
                }
                return e
            })


            if (mounted.current) {
                setData({ loading: false, data })
                setUserData(res[1].data.user)

            }
        }

        getData()
        return () => mounted.current = false
    }, [courseID, trainingId, username, restricted])

    // id is courseID
    const goModuleHist = (id) => {
        history.push('/training/' + id, { ...data.data.find(e => e.COURSEID === id), from: props.from, username, trainingId, })
    }

    const goQuizHist = (id) => {
        console.log(data.data.find(e => e.COURSEID === id))
        history.push('/training/viewQuiz/' + id, { label: data.data.find(e => e.COURSEID === id).label, from: props.from, username, trainingId, })
    }

    const goCertHist = () => {
        history.push('/training/viewQuiz/' + courseID, { label: "Certification Test", certTest: true, restricted: restricted, from: props.from, username, trainingId, })
    }


    const actionButtons = [
        { icon: "view", label: t('TrainingHistoryDetails.ModuleHistory'), action: goModuleHist, delete: false },
        { icon: "quiz", label: t('TrainingHistoryDetails.QuizHistory'), action: goQuizHist, delete: false, view: "hasQuiz" },
    ];

    const tableCells = restricted ? [
        { id: 'label', label: t('TrainingHistoryDetails.TrainingModule') , centered: false },
        { id: 'statusView', label: t('TrainingHistoryDetails.Status'), centered: false, hyperlink: goModuleHist},
        // { id: 'lastViewed', label: 'Last Viewed', centered: false },
        { id: 'highestScore', label:  t('TrainingHistoryDetails.HighestScore'), centered: false },
    ] :
    [
        { id: 'label', label: t('TrainingHistoryDetails.TrainingModule'), centered: false },
        { id: 'statusView', label: t('TrainingHistoryDetails.Status'), centered: false, hyperlink: goModuleHist},
        // { id: 'lastViewed', label: 'Last Viewed', centered: false },
        { id: 'highestScore', label:  t('TrainingHistoryDetails.HighestScore'), centered: false, hyperlink: goQuizHist },
    ] ;

    console.log(data)

    return (
        <>
            <PageHeader title={courseLabel} backButton />
            {data.loading ? <Loading /> :
                data.data === undefined ? <h1>No data found</h1> :
                    <>

                        <UserInfoDisplay userData={userData} restricted={restricted} />
                        <br />

                        <h2>{ t('TrainingHistoryDetails.TrainingType') + courseType}</h2>


                        <SimpleTable
                            data={data.data}
                            cellKey={"COURSEID"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={true}
                        />

                        <PageHeader title= {t('TrainingHistoryDetails.CertificationTestDetails')} />
                        <Container maxWidth="xs">
                            <Button variant="contained" color="primary" onClick={goCertHist} fullWidth>{t('TrainingHistoryDetails.ViewTestHistory')}</Button>
                        </Container>

                    </>
            }


        </>
    )
}

export default withTranslation()(TrainingHistDetails)